<template>
  <div class="park-info">
    <div>
      <el-row>
        <template
        v-for="item in BasicsList"
        >
          <el-col
          class="label"
          :key="`label-${item.value}`"
          :span="item.labelSpan">
            {{item.label}}
          </el-col>
          <el-col
          class="value"
          :key="`value-${item.value}`"
          :span="item.valueSpan">
            {{infoData[item.value] || '-'}}
            <span v-html="item.unit"></span>
          </el-col>
        </template>
      </el-row>
      <div class="divider"></div>
      <el-row>
      <template
        v-for="item in lesseeList"
        >
          <el-col
          class="label"
          :key="`label-${item.value}`"
          :span="item.labelSpan">
            {{item.label}}
          </el-col>
          <el-col
          class="value"
          :key="`value-${item.value}`"
          :span="item.valueSpan"
         >
            <div @click="itemDetails(item)">
              {{infoData[item.value] || '-'}}
              <span v-html="item.unit"></span>
            </div>
          </el-col>
        </template>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // 基础信息
      BasicsList: [
        // {
        //   label: '园区/写字楼等级:',
        //   value: 'parkLevel',
        //   labelSpan: 7,
        //   valueSpan: 5,
        //   unit: ''
        // },
        {
          label: '园区/写字楼属性:',
          value: 'parkBelong',
          labelSpan: 7,
          valueSpan: 5,
          unit: ''
        },
        {
          label: '停车位数量:',
          value: 'parkingAmount',
          labelSpan: 7,
          valueSpan: 5,
          unit: ''
        },
        {
          label: '停车价格:',
          value: 'parkingPrice',
          labelSpan: 7,
          valueSpan: 5,
          unit: '/小时'
        },
        {
          label: '房租均价:',
          value: 'rentPrice',
          labelSpan: 7,
          valueSpan: 5,
          unit: '元/m²/日'
        },
        {
          label: '物业均价:',
          value: 'managementFee',
          labelSpan: 7,
          valueSpan: 5,
          unit: '元/m²/月'
        }
      ],
      // 租房信息
      lesseeList: [
        {
          label: '办公面积:',
          value: 'officeArea',
          labelSpan: 5,
          valueSpan: 6,
          unit: 'm²'
        },
         {
          label: '装修免租期:',
          value: 'rentFreeMonth',
          labelSpan: 5,
          valueSpan: 6,
          unit: '月'
        },
         {
          label: '招商人员:',
          value: 'salesMan',
          labelSpan: 5,
          valueSpan: 6,
          unit: ''
        },
         {
          label: '联系电话:',
          value: 'telephone',
          labelSpan: 5,
          valueSpan: 6,
          unit: ''
        },
        {
          label: '物业公司:',
          value: 'managementCompany',
          labelSpan: 5,
          valueSpan: 6,
          unit: ''
        },
        {
          label: '物业办公室电话:',
          value: 'managementOfficePhone',
          labelSpan: 6,
          valueSpan: 5,
          unit: ''
        },
        {
          label: '物业经理电话:',
          value: 'managementManagerPhone',
          labelSpan: 5,
          valueSpan: 18,
          unit: ''
        },
         {
          label: '园区地址:',
          value: 'parkAddress',
          labelSpan: 5,
          valueSpan: 18,
          unit: ''
        },
      ],
      // 定位信息
      coordinateInfo: {
        33: {
          id: 33,
          coordinate: '31.217439,121.395187',
          name: '珍宝公寓',
          location: '上海市长宁区新渔东路289弄1-10号'
        },
        32: {
          id: 32,
          coordinate: '31.17215,121.35027',
          name: '七宝茂星广场',
          location: '七莘路3558号、吴宝路655号'
        },
        31: {
          id: 31,
          coordinate: '31.218097,121.392638',
          name: '新渔东路商铺',
          location: '新渔东路388、394号'
        },
        30: {
          id: 30,
          coordinate: '31.217309,121.380994',
          name: '铭晖商务楼',
          location: '哈密路422号-444号',
        },
        29: {
          id: 29,
          coordinate: '31.218221,121.391221',
          name: '海盈商务楼',
          location: '威宁路333号'
        },
        28: {
          id: 28,
          coordinate: '31.223048,121.361152',
          name: '鑫达科研楼',
          location: '广顺路33号A南座'
        },
        27: {
          id: 27,
          coordinate: '31.2166,121.376337',
          name: '新泾派出所',
          location: '剑河路500号',
        },
        10: {
          id: 10,
          name: '虹桥科技广场D座',
          coordinate: '31.225463,121.358675',
          location: '金钟路999号D栋',
        },
        11: {
          id: 11,
          name: '鑫达商务广场（共2栋）',
          coordinate: '31.230261,121.360875',
          location: '协和路1158号、北翟路1178号',
        },
        9: {
          id: 9,
          name: '虹桥中央大厦',
          coordinate: '31.225061,121.366114',
          location: '金钟路631弄2号'
        },
        4: {
          id: 4,
          name: '可乐路',
          coordinate: '31.211016,121.373309',
          location: '可乐路49-67号',
        },
        20: {
          id: 20,
          name: '鑫达大厦',
          coordinate: '31.211268,121.405669',
          location: '仙霞路318-322号',
        },
        18: {
          id: 20,
          name: '鑫达财富中心',
          coordinate: '31.226368,121.368298',
          location: '淞虹路152号',
        },
        17: {
          id: 17,
          name: '新泾事务受理中心',
          coordinate: '31.217795,121.378889',
          location: '哈密路431号',
        },
        3: {
          id: 3,
          name: '天涯商务楼',
          coordinate: '31.21767,121.380158',
          location: '哈密路433号',
        },
        16: {
          id: 16,
          name: '同仁医院善鑫老年服务公司',
          coordinate: '31.218296,121.38042',
          location: '哈密路419号、哈密路431号',
        },
        19: {
          id: 19,
          name: '鑫达产业园区',
          coordinate: '31.240882,121.355735',
          location: '临新路268号（9/10/11/16栋）',
        },
        12: {
          id: 12,
          name: '海益商务大厦',
          coordinate: '31.2213,121.391558',
          location: '天山路310、316号',
        },
      }
    }
  },
  methods: {
    itemDetails (item) {
      if (item.value === 'parkAddress') {
        // console.log(1111)
        console.log(this.infoData)
        if (!this.infoData.id || !this.coordinateInfo[this.infoData.id]) return
        let data = this.coordinateInfo[this.infoData.id]
        window.open(` http://api.map.baidu.com/marker?location=${data.coordinate}&title=${this.infoData.parkName}&content=${data.location}&output=html`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.park-info {
  color: #333;
  .label {
    color: #E9F5FF;
    font-size: 0.13rem;
    line-height: 0.3rem;
  }
  .value {
    color: #8CD8FF;
    font-size: 0.13rem;
    line-height: 0.3rem;
  }
  .divider {
    display: block;
    height: 2px;
    width: 100%;
    margin: 0.15rem 0;
    background: linear-gradient(to right, rgba(50,65,79,1.000), rgba(83,113,138,1.000));
  }
}
</style>